import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../components/BodyCopy";
import { Button, Layout, PageTitle } from "lola-framework-ui-test";
import { UserCheckIcon } from "lola-framework-ui-test/src/icons";
import { AuraLayout } from "../components/AuraLayout";
import { FlowHeroMark } from "../components/FlowHeroMark";
import { useStore } from "../store/globalState";
import { useLiveExitUrl } from "../hooks/useLiveExitUrl";
import {
  appendAnalyticsHandoff,
  getAnalyticsSession,
  getEvents,
  safeCapture,
} from "../analytics";
import { ScrollFadeIndicator } from "../components/ScrollFadeIndicator";

/**
 * Shown after splash when the depositor is still in CIP manual review.
 * They cannot continue the deposit; the only CTA returns to the host app
 * while the link is still valid (config then envelope callbackUrl).
 */
export const CipReviewPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const exitUrl = useLiveExitUrl();

  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, dropzoneColors, backgroundIcon } =
    colorConfig;

  useEffect(() => {
    safeCapture(getEvents().SCREEN_VIEW("cip_review"));
  }, []);

  const handleGoBack = () => {
    if (!exitUrl) return;
    safeCapture(getEvents().EXIT_CLICK, { screen: "cip_review" });
    const { sessionId, distinctId } = getAnalyticsSession();
    const handoffUrl =
      sessionId && distinctId
        ? appendAnalyticsHandoff(exitUrl, { sessionId, distinctId })
        : exitUrl;
    window.location.href = handoffUrl;
  };

  return (
    <AuraLayout colorConfig={colorConfig}>
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <UserCheckIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("cashDeposit.cipReview.title")}
              highlightColor={title}
              secudnary=""
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t("cashDeposit.cipReview.body")}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      {exitUrl && (
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={handleGoBack}
            >
              {t("cashDeposit.cipReview.cta")}
            </Button>
          </section>
        </Layout.Footer>
      )}
    </AuraLayout>
  );
});
